<template>
  <div>
    <Dialog
      width="710px"
      custom-class="authSelectDialog"
      :mobileRenderType="createRenderType == 'mobile' ? 'drawerDialog' : ''"
      :backgroundImage="false"
      :visible="popupVisible"
      @close="onCloseClick"
    >
      <div class="auth-select-box" aria-hidden="true">
        <div class="step text-[16px]">
          <div>1、为了您的账户安全，请完成个人实名认证或企业认证</div>
          <div>2、个人认证和企业认证仅支持相互切换一次</div>
          <div>3、企业认证 30 天内仅支持编辑一次</div>
        </div>
        <div class="info">
          <div class="item">
            <img src="@/assets/img/auth/person.png" alt="" />
            <div class="describe">
              <div class="flex-row-center">
                <div class="name font-bold text-[20px]">个人实名认证</div>
                <div
                  class="flag px-[8px] py-[2px] rounded-[4px] text-[12px] leading-[1.6] ml-[8px]"
                  :class="{
                    'bg-[rgba(255,160,43,0.2)] text-[#C56723]':
                      certificationState !== 2,
                    'bg-[rgba(28,255,130,0.1)] text-[#109312]':
                      certificationState === 2,
                  }"
                >
                  {{ certificationState === 2 ? "已认证" : "未认证" }}
                </div>
              </div>
              <div
                class="apply h-fit text-[14px] leading-[2] mt-[2px] text-[rgba(0,0,0,0.5)]"
              >
                适用于个人用户，账号归属个人
              </div>
            </div>
            <div class="flex1 flex justify-end items-center">
              <div
                v-if="personal_un_effect != 1 && certificationState != 2"
                class="auth-action-button auth-action-button--enabled pointer h-fit w-fit bg-[#000] text-[#fff] px-[32px] py-[6px] text-[14px] leading-[2] rounded-[40px]"
                @click="handlePersonalAuth"
              >
                个人认证
              </div>
              <div
                v-else
                class="auth-action-button auth-action-button--disabled h-fit w-fit bg-[rgba(0,0,0,0.1)] text-[#fff] px-[32px] py-[6px] text-[14px] leading-[2] rounded-[40px]"
              >
                个人认证
              </div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/img/auth/enterprise.png" alt="" />
            <div class="describe">
              <div class="flex-row-center">
                <div class="name font-bold text-[20px]">企业实名认证</div>
                <div
                  class="flag px-[8px] py-[2px] rounded-[4px] text-[12px] leading-[1.6] ml-[8px]"
                  :class="{
                    'bg-[rgba(255,160,43,0.2)] text-[#C56723]':
                      certificationState !== 1,
                    'bg-[rgba(28,255,130,0.1)] text-[#109312]':
                      certificationState === 1,
                  }"
                >
                  {{ certificationState === 1 ? "已认证" : "未认证" }}
                </div>
              </div>
              <div
                class="apply text-[14px] leading-[2] mt-[2px] text-[rgba(0,0,0,0.5)]"
              >
                适用于企业，学术机构等，账号归属企业
              </div>
            </div>
            <div class="flex1 flex justify-end items-center gap-2">
              <div
                v-if="enterprise_un_effect != 1 && certificationState != 1"
                class="auth-action-button auth-action-button--enabled pointer h-fit w-fit bg-[#000] text-[#fff] px-[32px] py-[6px] text-[14px] leading-[2] rounded-[40px]"
                @click="handleEnterpriseAuth"
              >
                企业认证
              </div>
              <div
                v-else
                class="auth-action-button auth-action-button--disabled h-fit w-fit bg-[rgba(0,0,0,0.1)] text-[#fff] px-[32px] py-[6px] text-[14px] leading-[2] rounded-[40px]"
              >
                企业认证
              </div>
              <div
                v-if="showEdit"
                class="text-[14px] leading-[2] pointer"
                :class="{
                  'text-blue-500': enterprise_un_effect_within_30_days == 0,
                  'text-gray-500': enterprise_un_effect_within_30_days == 1,
                  pointer: enterprise_un_effect_within_30_days == 0,
                }"
                @click="handleEnterpriseAuth"
              >
                编辑
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="personalVisible"
      width="480px"
      custom-class="personalAuthDialog"
      @close="onPersonalCloseClick"
    >
      <div>
        <div class="auth-form-title text-[18px]">个人认证</div>
        <div
          class="auth-form-content mt-[24px] bg-transparent p-0 rounded-none"
        >
          <PersonalInfo @cancelSubmit="onPersonalCloseClick"></PersonalInfo>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="enterpriseVisible"
      width="480px"
      custom-class="enterpriseAuthDialog"
      @close="onEnterpriseCloseClick"
    >
      <div>
        <div class="auth-form-title text-[18px]">企业认证</div>
        <div
          class="auth-form-content mt-[24px] bg-transparent p-0 rounded-none"
        >
          <EnterpriseInfo
            @cancelSubmit="onEnterpriseCloseClick"
            @confirmSumbit="onEnterpriseCloseClick"
          ></EnterpriseInfo>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { onMounted, computed, watch, reactive } from "vue";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore";
import Dialog from "@/components/basic/dialog/Dialog.vue";
import PersonalInfo from "@/components/personalInfo/personalInfo.vue";
import EnterpriseInfo from "@/components/enterpriseInfo/enterpriseInfo.vue";

const createLayoutStore = useCreateLayoutStore();
const userDataStore = useUserDataStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const {
  certificationState,
  enterprise_un_effect,
  personal_un_effect,
  certificationDetail,
  enterprise_un_effect_within_30_days,
} = storeToRefs(userDataStore);

const props = defineProps({
  remove: {
    type: Function, //传入移除节点方法,这里是createApp中的方法
    default: null,
  },
});
const popupVisible = ref(true);
const personalVisible = ref(false);
const enterpriseVisible = ref(false);

const onCloseClick = () => {
  popupVisible.value = false;
  props.remove();
};

const showEdit = computed(() => {
  console.log(certificationState.value, "certificationState");
  console.log(enterprise_un_effect.value, "enterprise_un_effect");
  console.log(personal_un_effect.value, "personal_un_effect");
  if (certificationState.value == 0) {
    return false;
  }

  if (certificationState.value == 1) {
    if (personal_un_effect.value == 1) {
      return true;
    }
  }

  if (certificationState.value == 2) {
    if (enterprise_un_effect.value == 0 && personal_un_effect.value == 1) {
      return true;
    }

    return false;
  }

  return true;
});

// 暴露关闭方法给外部调用
defineExpose({
  onCloseClick,
  close: onCloseClick,
});

const handlePersonalAuth = () => {
  popupVisible.value = false;
  personalVisible.value = true;
};

const handleEnterpriseAuth = () => {
  if (enterprise_un_effect_within_30_days.value == 1) {
    ElMessage.warning("30天内仅支持编辑一次");
    return;
  }
  popupVisible.value = false;
  enterpriseVisible.value = true;
};

const onPersonalCloseClick = () => {
  personalVisible.value = false;
  props.remove();
};

const onEnterpriseCloseClick = () => {
  enterpriseVisible.value = false;
  props.remove();
};

// const handleCancelPersonSubmit = () => {
//   personalVisible.value = false;
//   props.remove()
// }
onMounted(() => {
  userDataStore.getUserCertificationState();
});
</script>

<style lang="scss" scoped>
.auth-select-box {
  width: 646px;

  .step {
    height: 24px;
    overflow: hidden;
    padding-right: 0;
    color: #000;
    font-family: "Noto Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;

    > div:not(:first-child) {
      display: none;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 20px;

    .item {
      display: flex;
      box-sizing: border-box;
      width: 646px;
      height: 148px;
      margin-top: 0;
      padding: 24px;
      border: 1px solid #e7e7eb;
      border-radius: 16px;
      background: #fff;
      align-items: center;

      img {
        width: 175px;
        height: 100px;
        flex: 0 0 175px;
      }

      .describe {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 20px;
        min-width: 0;

        .name {
          color: #000;
          font-family: "Noto Sans", sans-serif;
          font-size: 18px;
          font-weight: 600;
          line-height: 28px;
          white-space: nowrap;
        }

        .flag {
          display: none;
        }

        .apply {
          margin-top: 4px;
          color: #5e5e66;
          font-family: "Noto Sans", sans-serif;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          white-space: nowrap;
        }
      }

      .flex1 {
        flex: 1;
        min-width: 104px;
        justify-content: flex-end;
      }

      .auth-action-button {
        box-sizing: border-box;
        width: 104px;
        height: 40px;
        padding: 8px 24px;
        border: 0;
        border-radius: 12px;
        background: #48e1eb !important;
        color: #000 !important;
        font-family: "Space Grotesk", sans-serif;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        white-space: nowrap;

        &--enabled {
          background: #48e1eb !important;
          color: #000 !important;
        }

        &--disabled {
          cursor: not-allowed;
          background: #f0f0f5 !important;
          color: #909099 !important;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .auth-select-box {
    width: 100%;

    .info {
      gap: 12px;
      padding-top: 16px;

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: auto;
        min-height: 148px;
        border: 0;
        background: rgba(0, 0, 0, 0.05);
        padding: 10px;

        img {
          width: 70%;
          max-width: 175px;
          height: auto;
          flex-basis: auto;
        }
        .describe {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-left: 0px;
          margin-top: 4px;
        }
        .apply {
          margin-bottom: 4px;
        }

        .auth-action-button {
          width: 104px;
          margin-top: 8px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.authSelectDialog {
  z-index: 10000 !important;

  .dialog-box {
    padding: 32px;
    border-radius: 24px;
  }

  .dialog-close {
    top: 16px;
    right: 16px;
  }
}

.personalAuthDialog,
.enterpriseAuthDialog {
  z-index: 10000 !important;

  .dialog-box {
    width: 480px !important;
    max-width: calc(100% - 32px);
    padding: 24px;
    border-radius: 24px;
    background: #fff !important;
  }

  .dialog-close {
    top: 16px;
    right: 16px;
  }

  .auth-form-title {
    color: #000;
    font-family: "Space Grotesk", sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 32px;
  }

  .auth-form-content {
    margin-top: 24px !important;
    background: transparent !important;
    padding: 0 !important;
  }

  .auth-form-content .enterprise-info {
    width: 100%;

    .apiForm {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .el-form-item {
      margin: 0;
    }

    .el-form-item__label {
      height: 20px;
      margin: 0 0 8px;
      padding: 0;
      color: #5e5e66;
      font-family: "Space Grotesk", sans-serif;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }

    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label::before {
      margin-right: 2px;
      color: #ff4560;
      font-size: 16px;
    }

    .el-input,
    .el-input__wrapper {
      height: 40px;
    }

    .el-input__wrapper {
      box-sizing: border-box;
      border: 1px solid #d5d5db;
      border-radius: 12px;
      background: #fff;
      box-shadow: none !important;
      padding: 0;
    }

    .el-input__inner {
      height: 38px;
      box-sizing: border-box;
      border: 0 !important;
      border-radius: 12px;
      padding: 0 12px;
      color: #282b31;
      font-family: "Plus Jakarta Sans", sans-serif;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.15px;
      line-height: 20px;
    }

    .el-input__inner::placeholder {
      color: #909099 !important;
      opacity: 1;
    }

    .el-form-item__error {
      color: #ff4560;
    }

    > .flex {
      display: flex;
      gap: 12px;
      width: 100%;
      margin-top: 24px !important;
    }

    > .flex > div {
      box-sizing: border-box;
      width: auto;
      height: 48px;
      flex: 1;
      margin: 0 !important;
      border-radius: 14px;
      font-family: "Space Grotesk", sans-serif;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }

    > .flex > div:first-child {
      border: 1px solid #d5d5db;
      color: #5e5e66;
      background: #fff;
    }

    > .flex > div:nth-child(2) {
      border: 0;
      color: #000;
      background: #48e1eb;
    }
  }
}

.enterpriseAuthDialog .auth-form-content .enterprise-info {
  .apiForm {
    gap: 24px;
  }

  .upload {
    box-sizing: border-box;
    width: 175px;
    height: 100px;
    border: 1px dashed #d5d5db;
    border-radius: 12px;
    background: #f7f7fa;
    overflow: hidden;
  }

  .upload .filepond--root {
    min-height: 100px !important;
  }

  .upload .upload-main {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    background: transparent;
  }

  .upload .upload-main .no-upload-img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
}

@media screen and (max-width: 768px) {
  .personalAuthDialog,
  .enterpriseAuthDialog {
    .dialog-box {
      width: calc(100% - 32px) !important;
      max-width: calc(100% - 32px);
      padding: 20px;
    }
  }
}
</style>
